import { CSSProperties, ReactNode } from 'react';
import './styles.css';

type InteractionBlockerPropsType = {
    children: ReactNode;
    style?: CSSProperties;
};

const InteractionBlocker = ({ children, style }: InteractionBlockerPropsType) => {
    return (
        <div className="interaction-blocker" style={style}>
            {children}
            <div className="interaction-blocker__overlay"></div>
        </div>
    );
};

export default InteractionBlocker;
